/* ==========================================================================
   Carduri de produs de aceeasi inaltime — istore24 (Yuva 12.0.0)
   De salvat ca assets/equalize-product-cards.js si inclus in theme.liquid:
     <script src="{{ 'equalize-product-cards.js' | asset_url }}" defer></script>

   De ce e nevoie de JS: in slider, Flickity pozitioneaza celulele absolut.
   Ele nu au un parinte cu inaltime fata de care sa se intinda, iar
   height: 100% ar fi circular (inaltimea viewport-ului se calculeaza chiar
   din inaltimea celulelor). Asa ca masuram noi cea mai inalta carte din
   fiecare grup si o aplicam tuturor.

   Cardurile sunt grupate dupa parintele lor, deci fiecare slider / grila
   se aliniaza separat — nu se amesteca sectiunile intre ele.
   ========================================================================== */
(function () {
  'use strict';

  var CARD = '.yv-product-card';
  var applying = false;
  var pending = null;

  function equalizeGroup(cards) {
    var i;

    /* Intai stergem inaltimea pusa anterior, ca sa masuram inaltimea
       naturala. Fara acest pas, valorile s-ar acumula la fiecare rulare. */
    for (i = 0; i < cards.length; i++) {
      cards[i].style.height = '';
    }

    var max = 0;
    for (i = 0; i < cards.length; i++) {
      var h = cards[i].offsetHeight;
      if (h > max) max = h;
    }
    if (!max) return;

    max = Math.ceil(max);
    for (i = 0; i < cards.length; i++) {
      cards[i].style.height = max + 'px';
    }
  }

  function run() {
    if (applying) return;
    applying = true;

    try {
      var cards = document.querySelectorAll(CARD);
      var groups = [];
      var parents = [];

      for (var i = 0; i < cards.length; i++) {
        var parent = cards[i].parentNode;
        var idx = parents.indexOf(parent);
        if (idx === -1) {
          parents.push(parent);
          groups.push([cards[i]]);
        } else {
          groups[idx].push(cards[i]);
        }
      }

      for (var g = 0; g < groups.length; g++) {
        equalizeGroup(groups[g]);
      }
    } catch (e) {}

    /* Eliberam abia dupa ce browserul a terminat de asezat, altfel
       propriile noastre modificari ar declansa o noua rulare. */
    requestAnimationFrame(function () { applying = false; });
  }

  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(run, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  /* Imaginile se incarca lazy si schimba inaltimea cardului dupa randare. */
  window.addEventListener('load', schedule);
  document.addEventListener('lazyloaded', schedule);

  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  /* Sectiunile cu taburi isi re-randeaza cardurile; Flickity remasoara. */
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (applying) return;
      schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Fontul se incarca dupa CSS si poate schimba inaltimea titlurilor. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule);
  }
})();